import { Link } from "react-router-dom";
import { FadeUp, PageHero, GhostLink } from "../components/Reveal";

function Block({ id, title, children, testId }) {
  return (
    <FadeUp>
      <section id={id} className="border border-white/5 bg-ink-2/40 p-8 scroll-mt-32" data-testid={testId}>
        <h2 className="font-serif text-2xl text-ivory font-light mb-5">{title}</h2>
        <div className="space-y-4 text-stone-mist text-sm font-light leading-relaxed">{children}</div>
      </section>
    </FadeUp>
  );
}

export default function Terms() {
  return (
    <main data-testid="terms-page">
      <PageHero eyebrow="Terms & Conditions" title="Our policies, plainly stated" sub="Celtic Gold is a small, family-run business based in Peel on the west coast of the Isle of Man." />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 pb-24 space-y-8">
        <Block id="about" title="About Celtic Gold" testId="terms-about">
          <p>
            Celtic Gold is a small, family-run business based in Peel on the west coast of the Isle of Man. We focus
            on producing goods to a consistently high standard and make every effort to provide fair and accurate
            descriptions of products available through this website.
          </p>
        </Block>

        <Block id="returns" title="Conditions of Sale — Returns & Exchanges" testId="terms-returns">
          <p>Our standard policy is to offer exchanges for goods.</p>
          <p>Exceptions apply where an item has been altered to meet a customer's specific requirements.</p>
          <p>As a rule, refunds are not provided unless goods are faulty.</p>
          <div className="border border-gold/25 bg-gold/5 px-5 py-4 text-ivory">
            If you are unsure about any aspect of a product or our policies, please contact us before making a purchase.
          </div>
        </Block>

        <Block id="ring-sizing" title="Ring Orders & Sizing" testId="terms-ring-sizing">
          <p>Please provide the correct ring size when placing your order.</p>
          <p>
            If the correct size cannot be confirmed, or an incorrect size has been ordered, we may be able to alter
            the ring where feasible. Additional charges may apply for size alterations, and not every ring can be
            resized.
          </p>
          <p>Uncertain about sizing? Contact us before ordering and we will be glad to help.</p>
          <p>
            <Link to="/contact?subject=Ring%20sizing" className="text-gold hover:text-gold-glow transition-colors text-xs uppercase tracking-[0.25em]" data-testid="ring-sizing-cta">
              Ask About Ring Sizing →
            </Link>
          </p>
        </Block>

        <Block id="order-confirmation" title="Order Confirmation" testId="terms-confirmation">
          <p>
            After an order has been placed, Celtic Gold will confirm acceptance by email. Your order is acknowledged
            at checkout and confirmed by email in accordance with these terms.
          </p>
        </Block>

        <Block id="disclaimer" title="Website Information & Disclaimer" testId="terms-disclaimer">
          <p>The content of this website is provided for general information and personal use.</p>
          <p>Information may change without notice.</p>
          <p>
            Celtic Gold Limited endeavours to keep website information accurate and up to date, but does not warrant
            that all information, products, services or graphics are complete, accurate, reliable, suitable or
            continuously available.
          </p>
          <p>Customers use information on this website at their own risk.</p>
        </Block>

        <FadeUp className="text-center pt-4">
          <GhostLink to="/contact" testId="terms-contact">Contact Celtic Gold</GhostLink>
        </FadeUp>
      </div>
    </main>
  );
}
